import { PERMISSION_DENIED_MESSAGE } from "../utils/entitlements";

export default function PermissionDeniedPanel({ productName = "This feature" }) {
  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        padding: "40px 24px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 560,
          padding: "36px 40px",
          borderRadius: 16,
          border: "1px solid #FECACA",
          background: "#FEF2F2",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: 18, fontWeight: 700, color: "#B91C1C", marginBottom: 10 }}>
          {PERMISSION_DENIED_MESSAGE}
        </div>
        <div style={{ fontSize: 14, color: "#7F1D1D", lineHeight: 1.5 }}>
          {productName} is not enabled for your organization. Ask your service provider to update permissions.
        </div>
      </div>
    </div>
  );
}
